import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "property-editor-kind"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_pair_toggle = _resolveComponent("ontos-pair-toggle")!
  const _component_ontos_select = _resolveComponent("ontos-select")!
  const _component_ontos_attribute_input = _resolveComponent("ontos-attribute-input")!
  const _component_ontos_relationship_input = _resolveComponent("ontos-relationship-input")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_form_panel = _resolveComponent("ontos-form-panel")!

  return (_openBlock(), _createBlock(_component_ontos_form_panel, _mergeProps(_ctx.heading, {
    saving: _ctx.saving,
    "save-disabled": !_ctx.canSave || _ctx.edit.unchanged,
    onSave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save()))
  }), {
    controls: _withCtx(() => [
      _renderSlot(_ctx.$slots, "controls", {
        dirty: _ctx.edit.dirty,
        resume: _ctx.resume
      }, undefined, true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_form, { ref: "form" }, {
        default: _withCtx(() => [
          (_ctx.isCreating)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ontos_pair_toggle, _mergeProps({
                  "model-value": _ctx.kind !== 'attribute'
                }, _ctx.kindPairs.species, {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.kind = $event ? 'relationship' : 'attribute'))
                }), null, 16, ["model-value"]),
                (_ctx.kind !== 'attribute' && _ctx.mirrorCandidates.length)
                  ? (_openBlock(), _createBlock(_component_ontos_pair_toggle, _mergeProps({
                      key: 0,
                      "model-value": _ctx.kind === 'reverse'
                    }, _ctx.kindPairs.mirror, {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.kind = $event ? 'reverse' : 'relationship'))
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_ontos_select, {
                          items: _ctx.mirrorCandidates,
                          "item-text": "label",
                          "item-value": "key",
                          label: _ctx.$tt('property-mirror-of'),
                          "hide-details": "auto",
                          modelValue: _ctx.mirrorKey,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mirrorKey) = $event))
                        }, null, 8, ["items", "label", "modelValue"])
                      ]),
                      _: 1
                    }, 16, ["model-value"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.kind === 'attribute')
            ? (_openBlock(), _createBlock(_component_ontos_attribute_input, {
                key: 1,
                ref: "input",
                value: _ctx.propertyModel,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.propertyModel = $event)),
                idea: _ctx.idea,
                workspace: _ctx.workspace,
                "fixed-alias": !_ctx.isCreating,
                resumed: _ctx.resumedEditor
              }, null, 8, ["value", "idea", "workspace", "fixed-alias", "resumed"]))
            : (_ctx.kind === 'relationship' || _ctx.mirror)
              ? (_openBlock(), _createBlock(_component_ontos_relationship_input, {
                  ref: "input",
                  key: _ctx.kind + _ctx.mirrorKey,
                  value: _ctx.propertyModel,
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.propertyModel = $event)),
                  other: _ctx.otherOriginal,
                  "other-start": _ctx.resumedOther,
                  onOther: _cache[5] || (_cache[5] = ($event: any) => (_ctx.otherDraft = $event)),
                  idea: _ctx.idea,
                  ideas: _ctx.workspace.ideas,
                  workspace: _ctx.workspace,
                  "fixed-alias": !_ctx.isCreating,
                  "fixed-destination-class": !_ctx.isCreating,
                  resumed: _ctx.resumedEditor
                }, null, 8, ["value", "other", "other-start", "idea", "ideas", "workspace", "fixed-alias", "fixed-destination-class", "resumed"]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    _: 3
  }, 16, ["saving", "save-disabled"]))
}